import React from 'react';
import { NavLink } from 'react-router-dom'

export default class Message extends React.Component {
    render() {
        const {linkId, linkName} = this.props;
        if (linkId && linkName) {
            return (<div>
                    {this.props.message}
                    <NavLink to={`./${linkId}`}>{linkName}</NavLink>
                    </div>)
        } else {
            return (<div>{this.props.message}</div>)
        }
    }
}